import React from "react";
import { styled } from "@mui/material/styles";
import { IconButton, Tooltip } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import colors from "assets/theme-dark/base/colors";

interface CollapseButtonProps {
  isCollapsed: boolean;
  onToggle: () => void;
}

const CollapseButton: React.FC<CollapseButtonProps> = ({ isCollapsed, onToggle }) => {
  return (
    <CollapseIconContainer>
      <Tooltip title={isCollapsed ? "Expand All" : "Collapse All"} placement="left-end">
        <IconButton
          onClick={onToggle}
          size="large"
          sx={{
            padding: "4px",
            "&:hover": {
              backgroundColor: "transparent",
              "& svg": {
                color: colors.grey[400],
              },
            },
          }}
        >
          {isCollapsed ? (
            <ExpandMoreIcon sx={{ color: colors.grey[900], fontSize: "1rem" }} />
          ) : (
            <ExpandLessIcon sx={{ color: colors.grey[900], fontSize: "1rem" }} />
          )}
        </IconButton>
      </Tooltip>
    </CollapseIconContainer>
  );
};

const CollapseIconContainer = styled("div")({
  position: "absolute",
  right: -7,
  top: 19,
  transform: "translate(-50%, -50%)",
  zIndex: 10,
});

export default CollapseButton;
